/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TasksAliases {
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  TASKS_LAYOUT = 'tasks-layout',
  TASKS_SIDE_BAR_FRAGMENT = 'tasks-side-bar-fragment',
  WIZARD = 'wizard',
  WIZARD_PANEL = 'wizard-panel',
}
export { TasksAliases };
